import { initialiseComponents } from "../../core";
import Component from "../component.abstract";
import AlertesHome from "./alertes-home";


export default class AlertesVide extends Component {
  constructor(private props: unknown, element: HTMLElement) {
    super(props, element);
  }

  mounted(): void {
    this.injectTemplate();

    PubSub.subscribe("alertes-home.loaded", (msg:string, instance: AlertesHome) => {
      if(instance.data) {
        // Add GA events
        if (
          instance.data.trackingsClick &&
          instance.data.trackingsClick.length
        ) {
          const submitButton = this.element.querySelector(".createAlert");
          submitButton.setAttribute(
            "data-track",
            JSON.stringify(instance.data.trackingsClick[0])
          );
        }
        if (instance.data.trackingsLoad && instance.data.trackingsLoad.length) {
          const span = this.element.querySelector("span");
          const eventanalytics = instance.data.trackingsLoad[0];
          eventanalytics.trigger = "init";
          span.setAttribute("data-track", JSON.stringify(eventanalytics));
        }
      }
      this.displayResults();
    });
  }

  displayResults(): void {
    document
      .querySelector("div[data-alerte-home]>div.lazy")
      .classList.add("hide");
    document
      .querySelector("div[data-alerte-home]>div.hide:not(.lazy)")
      .classList.remove("hide");
    document
      .querySelector("section.alertes .header.lazy-loading")
      .classList.remove("lazy-loading");
  }

}
